export default "__VITE_ASSET__CyT4j$9N__"